import React from "react";
import PropTypes from "prop-types";

const Tags = props => {
	const { tags } = props;

	return (
		<div className="tags">
			{tags &&
				tags.map(tag => (
					<div key={tag} className="react-tags__selected-tag">
						<span className="react-tags__selected-tag-name">{tag}</span>
					</div>
				))}
		</div>
	);
};

Tags.propTypes = {
	tags: PropTypes.array,
};

export default Tags;
